module.exports = __webpack_public_path__ + "img/0-82.80e1d908.jpg";